import { createApiSlice } from "@common";
import { GET_ORG_USER } from "@routes";

// Define the API config array
const apiConfig = [
  {
    name: "getProjectUser",
    method: "get",
    url: GET_ORG_USER,
    stateKey: "data",
  },
];

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    selectedData: {}
  },
  reducers: {
  },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "projectUsers",
  apiConfig,
  customReducers
);
const projectUsersSlice = slice;
// Export the slice's reducer
export default projectUsersSlice.reducer;


// Destructure and export thunks directly from thunksExports
export const {
  getProjectUser,
} = thunks;

// Destructure and export actions directly from actions

